/**
 * exportTableToExcel
 * Converts a 2D array of table data (headers + rows) to a .xlsx file
 * and triggers a browser download.
 *
 * @param {string[][]} tableData  - 2D array where index 0 = header row
 * @param {string}     filename   - Desired filename without extension
 */
export async function exportTableToExcel(tableData, filename = 'table_export') {
  const XLSX = await import('xlsx-js-style');

  // Create a worksheet from the 2D array
  const ws = XLSX.utils.aoa_to_sheet(tableData);

  // ── Bold the header row (row 0) ──────────────────────────────────────────
  if (tableData.length > 0) {
    const numCols = tableData[0].length;
    for (let c = 0; c < numCols; c++) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c });
      if (ws[cellAddress]) {
        ws[cellAddress].s = {
          font: { bold: true },
          fill: { fgColor: { rgb: 'F3F4F6' } },
          alignment: { horizontal: 'left' },
        };
      }
    }
  }

  // Auto-fit column widths based on max content length in each column
  const colWidths = tableData.reduce((acc, row) => {
    row.forEach((cell, colIdx) => {
      const len = String(cell ?? '').length;
      acc[colIdx] = Math.max(acc[colIdx] ?? 10, len + 4);
    });
    return acc;
  }, []);
  ws['!cols'] = colWidths.map((w) => ({ wch: Math.min(w, 60) }));

  // Create workbook and append worksheet
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  // Trigger download
  XLSX.writeFile(wb, `${filename}.xlsx`);
}
